import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { HOW_TO_STEPS } from "../../lib/constants";

export const HowToBuy = () => {
  return (
    <section className="py-24 sm:py-32 bg-white" data-testid="how-to-buy">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-12 gap-10 mb-16 items-end">
          <div className="md:col-span-8">
            <div className="text-[10px] uppercase tracking-[0.3em] text-brand mb-5">A Simple Process</div>
            <h2 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
              How to access <em className="text-brand">medical cannabis</em> in DC.
            </h2>
          </div>
          <div className="md:col-span-4">
            <p className="text-ink-muted leading-relaxed">
              From self-certification to delivery — four steps that take less time than ordering lunch.
            </p>
          </div>
        </div>

        <ol className="grid md:grid-cols-2 lg:grid-cols-4 gap-0 border-t border-l border-black/10">
          {HOW_TO_STEPS.map((s, i) => (
            <li key={s.n} className="p-8 border-r border-b border-black/10 hover:bg-[#FAFAFA] transition-colors group"
                data-testid={`how-step-${i+1}`}>
              <div className="font-serif text-brand text-5xl leading-none mb-8 group-hover:translate-x-1 transition-transform">
                {s.n}
              </div>
              <h3 className="font-serif text-2xl leading-tight mb-3">{s.title}</h3>
              <p className="text-base text-ink-muted leading-relaxed">{s.copy}</p>
            </li>
          ))}
        </ol>

        <div className="mt-14 flex flex-col sm:flex-row gap-3">
          <Link
            to="/self-certify"
            className="inline-flex items-center gap-2 bg-brand hover:bg-brand-600 text-white px-7 py-4 text-[12px] uppercase tracking-[0.22em] transition-colors"
            data-testid="self-certify-btn"
          >
            Self-Certify in 10 Minutes <ArrowUpRight size={14} />
          </Link>
          <Link
            to="/menu"
            className="inline-flex items-center gap-2 bg-ink hover:bg-black text-white px-7 py-4 text-[12px] uppercase tracking-[0.22em] transition-colors"
            data-testid="browse-menu-btn"
          >
            Browse Menu <ArrowUpRight size={14} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HowToBuy;
